import * as ColorUtils from '../../../../shared/app/utils/color-utils';
import { timerHelperModule } from '../../../../shared/app/helpers/timer-helper';
import { secondsToTimeFilterModule } from '../../../../shared/app/filters/seconds-to-time';
import { timeRemainingFilterModule } from '../../../../shared/app/filters/time-remaining';
import timerWidgetTemplate from './timer-widget.tpl.html';
import './timer-widget.less';

const AUTO_HIDE_TIMER = 20000; // Autohide the timer after 20 seconds

const COLORS = [
  [0, '#AAAAAA'],
  [40, '#AAAAAA'],
  [50, '#4BB05D'],
  [70, '#4BB05D'],
  [85, '#EEB854'],
  [98, '#B63D4C'],
  [100, '#B63D4C'],
];

function progressToColors(progress) {
  for (let i = 1; i < COLORS.length; i++) {
    let c = COLORS[i];
    if (progress === c[0]) {
      return { c1: c[1], c2: c[1], ratio: 0 };
    }
    if (progress < c[0]) {
      let c1 = COLORS[i - 1];
      let ratio = (progress - c1[0]) / (c[0] - c1[0]);
      return { c1: c1[1], c2: c[1], ratio };
    }
  }
}

export const timerWidgetComponentModule = angular
  .module('Q.components.timer-widget', [
    timerHelperModule,
    secondsToTimeFilterModule,
    timeRemainingFilterModule,
  ])

  .component('timerWidget', {
    bindings: {
      timer: '<',
      timerOnly: '<',
      showOnChange: '<',
    },
    template: timerWidgetTemplate,
    controller: 'TimerWidgetCtrl',
  })
  .controller(
    'TimerWidgetCtrl',
    function TimerWidgetCtrl($scope, $element, $filter, $timeout, timerHelper) {
      const ctrl = this;

      const timeRemaining = $filter('timeRemaining');
      const secondsToTime = $filter('secondsToTime');

      function updateTimer() {
        const timer = ctrl.timer;
        const timerTime = timer ? timer.time : 0;
        const progress = timer ? timer.progress() : 0;
        const progressColorRGB = ColorUtils.blend(progressToColors(progress));
        const progressColor = ColorUtils.rgb2hex(progressColorRGB);

        const timeText = $element.querySelector('.time');
        let text = '--:--:--';
        if (timer) {
          if (ctrl.timerOnly) {
            // show a human formatted remaining minutes, rounded down
            text = timeRemaining(timerTime, 's');
            timeText.css('color', progressColor);
          } else {
            text = secondsToTime(timerTime);
          }
        }
        timeText.text(text);

        if (ctrl.countUp) {
          $element.querySelector('.count-up-timer').css('color', progressColor);
        } else {
          const rightHalf = $element.querySelector('svg .timer-right-half');
          const leftHalf = $element.querySelector('svg .timer-left-half');
          const watchHand = $element.querySelector('svg .watch-hand');
          const progressFill = ColorUtils.blend2hex({
            c1: '#FFFFFF',
            c2: progressColorRGB,
            ratio: 0.5,
          });

          watchHand.css('transform', `rotate(${progress * 3.6}deg)`);

          // For the following, we're using two half circles that overlap. If we're below 50,
          // the left side hides some part of the right side, and the right rotates around up to 50%
          // Once we're over 50%, the right is static, and the left now rotates through a half turn
          // This creates the illusion of a radial fill
          leftHalf.toggleClass('timer-progress-colors', progress >= 50);
          if (progress < 50) {
            rightHalf.css({
              transform: `rotate(${(progress - 50) * 3.6}deg)`,
              fill: progressFill,
            });
            leftHalf.css({
              transform: `rotate(0)`,
              fill: null,
            });
          } else {
            rightHalf.css({
              transform: `rotate(0)`,
              fill: progressFill,
            });
            leftHalf.css({
              transform: `rotate(${(progress - 100) * 3.6}deg)`,
              fill: progressFill,
            });
          }
        }
      }

      let timerTickListenerOff = null;

      function listen() {
        if (ctrl.timer) {
          timerTickListenerOff = ctrl.timer.on('tick', updateTimer);
        }
      }

      function stopListening() {
        if (timerTickListenerOff) timerTickListenerOff();
        timerTickListenerOff = null;
      }

      function initTimer() {
        ctrl.countUp = !!(ctrl.timer && ctrl.timer.isCountUp);
        stopListening();
        listen();
        toggleTime(!!ctrl.timer);
      }

      let manualTimeChange = false;
      let autoTimerHide = null;

      function toggleTime(state = !ctrl.showTime) {
        ctrl.showTime = state;
        updateTimer();

        if (autoTimerHide) {
          timerHelper.longTimeout.cancel(autoTimerHide);
          autoTimerHide = null;
        }

        if (state && !manualTimeChange) {
          autoTimerHide = timerHelper.longTimeout(() => {
            toggleTime(false);
          }, AUTO_HIDE_TIMER);
        }
      }

      ctrl.$onInit = () => {
        initTimer();

        if (ctrl.timerOnly) {
          $element.addClass('timer-only');
        }

        $element.on('click', () => {
          if (ctrl.timer) {
            manualTimeChange = true;
            $scope.$applyAsync(() => toggleTime());
          }
        });

        // force re-rendering after the template has loaded
        $timeout(updateTimer);

        ctrl.$onChanges = (changes) => {
          if (changes.timer) {
            initTimer();
          }
          if (changes.showOnChange && !manualTimeChange) {
            toggleTime(true);
          }
        };
      };
    },
  );
